import { C as CosmosAssetItemBase$1, d as defineCustomElement$1 } from './cosmos-asset-item-base2.js';

const CosmosAssetItemBase = CosmosAssetItemBase$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosAssetItemBase, defineCustomElement };
